import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-hidden symbol" }
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden translate-y-0" }
const _hoisted_4 = { class: "pointer-events-none fixed inset-y-0 bottom-0 sm:right-0 flex sm:max-w-full w-full sm:w-auto pt-40 sm:pt-0 sm:pl-10" }
const _hoisted_5 = { class: "flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl" }
const _hoisted_6 = { class: "px-4 sm:px-6" }
const _hoisted_7 = { class: "flex items-start justify-between" }
const _hoisted_8 = { class: "ml-3 flex h-7 items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -inset-2.5" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close panel", -1)
const _hoisted_11 = { class: "relative mt-6 flex-1 px-4 sm:px-6" }

import { // icons
		XMarkIcon
	} from '@heroicons/vue/24/outline'

	import { // ui
		Dialog,
		DialogPanel,
		DialogTitle,
		TransitionChild,
		TransitionRoot
	} from '@headlessui/vue'

	import { // vue
		ref
	} from 'vue'

	/*eslint-disable*/
	
	const __default__ = { name: 'TwDrawer' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		title: {
			type: String,
			default: ""
		}
	},
  setup(__props, { expose }) {

const props = __props;

	

	const open = ref(false)

	expose({
		open
	})
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: open.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        class: "relative z-[999]",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (open.value = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-in-out duration-300",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in-out duration-300",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "transform transition ease-in-out duration-300",
                  "enter-from": "translate-y-full sm:translate-y-0 sm:translate-x-full",
                  "enter-to": "translate-y-0 sm:translate-y-0 sm:translate-x-0",
                  leave: "transform transition ease-in-out duration-300",
                  "leave-from": "translate-y-0 sm:translate-y-0 sm:translate-x-0",
                  "leave-to": "translate-y-full sm:translate-y-0 sm:translate-x-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "pointer-events-auto w-screen sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_unref(DialogTitle), { class: "text-2xl font-semibold leading-6 text-gray-900" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(__props.title), 1)
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("button", {
                                  id: "close-panel",
                                  type: "button",
                                  class: "relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brandRed focus:ring-offset-2",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = false))
                                }, [
                                  _hoisted_9,
                                  _hoisted_10,
                                  _createVNode(_unref(XMarkIcon), {
                                    class: "h-6 w-6",
                                    "aria-hidden": "true"
                                  })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _renderSlot(_ctx.$slots, "default")
                          ])
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})